// extracted by mini-css-extract-plugin
module.exports = {"blockRow":"BlockTree_blockRow__80Vim","blockRowActions":"BlockTree_blockRowActions__GDOGf","fakeHover":"BlockTree_fakeHover__TKaWl"};